module.exports = __webpack_public_path__ + "static/guardiancapital-logo-c964755c0fc710e03201904e7cc052ad.png";